import { useFormat } from 'vivat';

export default {
  types: {
    _primaryControls: {
      width: '4rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    code: {
      name: 'รหัส',
      width: '6rem',
    },
    name: {
      name: 'ชื่อ',
      width: '1fr',
      class: {
        text: 'text-left',
        cell: 'text-center',
      },
    },
    locationProvince: {
      name: 'จังหวัด',
      width: '1.5fr',
      class: {
        text: 'text-left',
        cell: 'text-center',
      },
      filter: (val: string, row: any) => `${row.item.location.length > 0 ? row.item.location[0].province?.nameInThai : ''} ${row.item.location.length > 1 ? `...และอีก ${row.item.location.length - 1} รายการ` : ''}`,
    },
    locationDistrict: {
      name: 'อำเภอ/เขต',
      width: '1.5fr',
      class: {
        text: 'text-left',
        cell: 'text-center',
      },
      filter: (val: string, row: any) => `${row.item.location.length > 0 ? row.item.location[0].district?.nameInThai : ''} ${row.item.location.length > 1 ? `...และอีก ${row.item.location.length - 1} รายการ` : ''}`,
    },
    distanceType: {
      name: 'ประเภท',
      width: '6rem',
      filter: (val: string) => {
        if (val === 'NEAR') return 'ใกล้';
        if (val === 'MODERATE') return 'กลาง';
        return 'ไกล';
      },
    },
    // eslint-disable-next-line
    hub_id: {
      name: 'Hub',
      width: '6rem',
      filter: (val: any, row: any) => row.item.hub?.name || '',
    },
    // 'user.name': {
    //   name: 'ผู้ดำเนินการ',
    //   width: '8rem',
    // },
  },
  sortable: [
    'name',
    'code',
    'distanceType',
  ],
};
